import React from 'react';
import { PEOPLE } from './portalSpaces';

/* Shared space-identity visuals: the rounded icon chip in the space hue and the
   stacked member avatars. Kept tiny + presentational so the hub, switcher and
   shell header all render identity the same way. */

export function SpaceChip({ space, size = 44, radius = 13 }) {
	return (
		<span
			className='psp-chip'
			style={{
				'--psp-accent': `var(--space-${space.key})`,
				'--psp-chip-size': `${size}px`,
				'--psp-chip-radius': `${radius}px`,
			}}>
			<i className={`fa-sharp-duotone fa-solid ${space.icon}`} />
		</span>
	);
}

export function AvatarStack({ members = [], size = 22 }) {
	return (
		<div className='psp-avatars'>
			{members.map((key) => {
				const person = PEOPLE[key];
				if (!person) return null;
				return (
					<span
						key={key}
						className='psp-avatar'
						title={person.name}
						style={{
							'--psp-person': person.color,
							'--psp-avatar-size': `${size}px`,
						}}>
						{person.initials}
					</span>
				);
			})}
		</div>
	);
}
